import React from 'react';
import StickyTip from '../common/stickyTip';
import BestPerks from '../common/bestPerks';
import Card from '../common/card';
import { PerkList } from '../common/perkList';
import { planList, perkList } from './plansData';
import Statistic from '../../statistic';

const renderPlansList = ({ id, name, price, shortDescription, perkCount }) => 
  <li key={id} className="billing-plans-list-item">
    <Card>
      <div className="billing-plan-title">
        <span>{name}</span>
        <span>${price}</span>
      </div>
      <p className="billing-plan-description">{shortDescription}</p>
      {perkCount > 0 && <p className="billing-plan-perks-text">
        {perkCount} Bonus perk{perkCount > 1 && 's'} of your choice
      </p>}
    </Card>
  </li>

const BillingPlansList = ({ title, fitlerPlans }) => {
  return <div className="billing-plans">
    <h6 className="billing-plans-title -step">      
      {title.split('\n').map((el, idx) => <span key={idx}>{el}</span>)}
    </h6>
    <ul className="billing-plans-list">
      {planList.filter(fitlerPlans).map(renderPlansList)}
    </ul>
  </div>;
}

const PlansInclude = () => {
  const handleDetailsClick = (idx) => {
    Statistic.updateValue(`perks.${idx}.LandingDetailsCount`);
  };
  return <div>
    <span>Choose your perk.</span>
    <div className="perk-wrapper">
      <PerkList list={perkList} onDetailsClick={handleDetailsClick} />
    </div>
  </div>
}

const Landing = ({ onContinue }) => {
  return <div className="layout">
    <StickyTip/>
    <div className="landing content -bau has-sticky-tip">
    <BestPerks
      titleOnCenter
      text="Customize our best unlimited plans with bonus perks." />
  
      <div>
        <BillingPlansList
          title={`Choose an\nunlimited plan.`}
          fitlerPlans={(plan) => plan.perkCount === 0} />
        <BillingPlansList
          title={`Or customize\nyour own.`}
          fitlerPlans={(plan) => plan.perkCount !== 0} />
        <PlansInclude/>
      </div>
  
      <footer>
        <button onClick={onContinue} className="button" type="button">Get started</button>
      </footer>
    </div>
  </div>
};

export default Landing;
